export default "__VITE_ASSET__4499faa2__"